import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { useNoSubmit } from "src/apps/AppFlow/pages/hooks";
import { BooleanRadioOptions, FormFlowPage } from "src/components";
import { BoldText } from "src/components/v1";
import { createStyles } from "src/styles";

export interface PropertyPlansProps {
  onChange: (value: boolean) => void;
  value?: boolean;
  propertyAddress?: string;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const styles = createStyles({
  text: {
    fontSize: 16,
    marginBottom: 24,
  },
  radio: {
    marginBottom: 50,
  },
});

const PropertyPlans = ({
  onNext,
  onBack,
  style,
  focusRef,
  value,
  onChange,
  propertyAddress,
  ...props
}: PropertyPlansProps) => {
  const validate = useCallback(() => value !== undefined, [value]);
  const { handleNext, nextDisabled } = useNoSubmit({ onNext, validate });

  return (
    <FormFlowPage
      {...props}
      title={`Do you plan to sell ${propertyAddress || "this property"}?`}
      description="Knowing this will help Fraction understand what is going on if your files change materially through the process."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
    >
      <BoldText style={styles.text} paragraph>
        Do you plan on selling this property before or during the process of getting a mortgage with Fraction?
      </BoldText>
      <BooleanRadioOptions style={styles.radio} focusRef={focusRef} onChange={onChange} value={value} />
    </FormFlowPage>
  );
};

export default memo(PropertyPlans);
